import { ReactNode } from 'react';

import { styled } from 'styled-components';

import { HeaderText, Text } from '../styles/text';
import ErrorIcon from './assets/error-icon.svg?react';

interface ErrorPageComponent {
  header: ReactNode;
  message: ReactNode;
  cta?: ReactNode;
}

const ErrorBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 296px;
  gap: 12px;
  margin: 5rem auto 3rem;
`;

const CtaWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 1em 0;
`;

export const ErrorPageComponent = ({ header, message, cta }: ErrorPageComponent) => (
  <ErrorBody>
    <ErrorIcon />
    <HeaderText $textAlign="center" $fontSize="xxxlarge">
      {header}
    </HeaderText>
    <Text $textAlign="center" $fontSize="medium" $lineHeight="150%" $color="grayLightest">
      {message}
    </Text>
    {cta && <CtaWrapper>{cta}</CtaWrapper>}
  </ErrorBody>
);
